import React, {useState} from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DateRangeIcon from '@material-ui/icons/DateRange';
import RateReviewIcon from '@material-ui/icons/RateReview';
import { Button } from '@material-ui/core';
import moment from 'moment';

import DashboardCountBox from '../DashboardCountBox';
import RecordsListForHazards from '../RecordsListForHazards';
import { buttonNames } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  apaper: {
    padding: 16,
    margin: 16
  },
  titleContainer: {
    position: 'relative',
    top: -16
  },
  bladeIcon: {
    position: 'absolute'
  },
  bladeTitle: {
    marginTop: -4,
    position: 'absolute',
    left: 32,
    top: 6
  },
  countBoxContainer: {
    display: 'flex',
    marginTop: 24
  },
  countBox: {
    width: '100%'
  },
  seeMoreButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8
  },
  seeMoreButton: {
    background: '#54a000',
    color: 'white',
    width: 150,
    height: 36,
    '&:hover': {
      background: 'white',
      color: '#54a000',
      border: '1px solid #54a000'
    }
  },
  noRecords: {
    fontSize: 20,
    textAlign: 'center',
    color: '#424242',
    marginBottom: 0
  }
}));

function HazardDashboardBlade(props) {
  const classes = useStyles();
  const {
    branchId,
    fetchAllHazardsForBranch,
    allHazards,
    setCurrentBranchesRecord,
    handleHazardItemEditClick
  } = props;

  const[seeMore, setSeeMore] = useState(true);

  let hazards = allHazards;

  React.useEffect(
    () => {
      if (branchId) {
        fetchAllHazardsForBranch(branchId);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [branchId]
  );

  if (hazards.length > 0) {
    //removing events with not nextEventDateUTC
    hazards = hazards.filter((hazard) => hazard.nextReviewDate !== null);

    //Order events based on date
    hazards &&
      hazards.sort(function (a, b) {
        return new Date(a.nextReviewDate) - new Date(b.nextReviewDate);
      });

    //removing events that are more than a month due
    const nextOneMonthDate = moment().add(1, 'months');
    hazards = hazards.filter(
      (hazard) => new Date(hazard.nextReviewDate) < nextOneMonthDate
    );
  }

  const upcomingHazardReviews = hazards.filter(
    (hazard) => new Date(hazard.nextReviewDate) >= new Date()
  );
  const overHazardReviews = hazards.filter(
    (hazard) => new Date(hazard.nextReviewDate) < new Date()
  );

  const handleAddEditClick = (item) => {
    setCurrentBranchesRecord(buttonNames.HAZARDS);
    handleHazardItemEditClick(item);
  };


  const handleSeeMoreButtonForHazardsClick = (recordType) => {
    setSeeMore(false);
  };
  const handleSeeLessButtonForHazardsClick = (recordType) => {
    setSeeMore(true);
  };

  return (
    <React.Fragment>
      <Paper className={classes.apaper}>
        <React.Fragment>
          <h3 className={classes.titleContainer}>
            <RateReviewIcon className={classes.bladeIcon} />
            <span className={classes.bladeTitle}>Hazard Reviews</span>
          </h3>

          <div className={classes.countBoxContainer}>
            <div className={classes.countBox}>
              <DashboardCountBox
                count={upcomingHazardReviews.length}
                label="upcoming"
              />
            </div>
            <div className={classes.countBox}>
              <DashboardCountBox
                count={overHazardReviews.length}
                label="overdue"
                isDanger={overHazardReviews.length > 0}
              />
            </div>
          </div>
          <RecordsListForHazards
            items={hazards}
            titleField="description"
            subTitleField={null}
            dateLabel="Next"
            dateField="nextReviewDate"
            handleAddEditClick={handleAddEditClick}
            seeMore = {seeMore}
          />

          {hazards.length === 0 ? (
            <p className={classes.noRecords}>No Hazards</p>
          ) : null}

          {hazards.length > 5 ? (
            <div className={classes.seeMoreButtonContainer}>
                {seeMore ? (<Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeMoreButtonForHazardsClick(buttonNames.HAZARDS)
              }
            >
              See More
            </Button>) : (<Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeLessButtonForHazardsClick(buttonNames.HAZARDS)
              }
            >
              See Less
            </Button>) }
            </div>
          ) : null}
        </React.Fragment>
      </Paper>
    </React.Fragment>
  );
}

export default HazardDashboardBlade;
